import React, { useState, useEffect, isValidElement } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import {
  Row,
  Col,
  Container,

} from "reactstrap";
import { useHistory } from "react-router-dom";
import Button from "../../../layout/Button";
import { Drawer } from "@material-ui/core";

import { useDispatch } from "react-redux";
import LoaderCustom from "../../../common/LoaderCustom";
import Toaster from "../../../common/Toaster";

import { useForm, Controller } from "react-hook-form";


import {
  TextFieldHookForm,
  SearchableSelectHookForm,
} from "../../../layout/HookFormInputs";
import {
  checkWhiteSpaces,
  userDetails,
} from "../../../../helper";
import { addNewSocMaster, fetchAllSocMasterList, getAllPlantMaster, getSocMasterDetailsById } from "../Action";
const AddSocMaster = (props) => {

  const Id = props?.open?.id;
  const guid = props?.open?.guid;
  // const { handleSubmit, control } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [plantList, setPlantList] = useState([]);
  const [loader, setloader] = useState(false);
  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting, isSubmitted, isValid, errors },
  } = useForm({ defaultValues: { IsActive: true }, mode: "onChange" });

  const [SocMasterData, setSocMasterData] = useState(null);

  useEffect(() => {

    getAllPlantMasterList();
    if (guid) {
      getSocMasterDetailsById(guid)
        .then(async (res) => {
          const socCodeMasterData = res?.Data;

          // const masterUpdateRequestData = res?.Data;

          const data = { ...socCodeMasterData };

          setSocMasterData(data);
          if (data.PlantId) {
            setValue("PlantId", {
              value: data?.PlantId || "",
              label: data?.PlantName || "",
            });
          }
          // setValue("PlantId", data.PlantId);
          setValue("SocialInsCode", data.SocialInsCode);
          // setValue("VendorCode", data.vendorCode);
          setValue("Id", data.Id);
        })
        .catch((error) => {

          setLoading(false); // Stop loading
        });
    } else {
      setLoading(false); // Stop loading
      reset();
    }
  }, [guid, reset]);


  const getAllPlantMasterList = (props) => {

    setLoading(true); // Set loading to true during data fetching
    getAllPlantMaster()
      .then((res) => {
        setPlantList(res?.Data); // Update state with response data


      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };

  const cancel = () => {
    // setValue('ApproveAction', false);
    // handleSubmit(onSubmit)();
    props.closeDrawer();

    reset();
  };
  const closebtn = () => {
    props.closeDrawer();
    reset();
  };
  const getUsers = async (currentPage, pageSize, sortOrder, fieldName) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllSocMasterList({
          current_page: currentPage,
          per_page: pageSize,
          sortOrder: sortOrder,
          sortField: fieldName,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };
  const onSubmit = async (data) => {
    

    setLoading(true); // Set loading to true during submission
    const userDetail = userDetails();

    if (Id) {
      const updatedPayload = {
        Id: Id,
        PlantId: data.PlantId.value,
        SocialInsCode: data.SocialInsCode,
        IsActive: true,
        IsDeleted: false,
        // ApproveOrRejectBy: userDetail.Id,
      };
      dispatch(
        addNewSocMaster(updatedPayload, (res) => {

          reset();
          setLoading(false); // Set loading to false regardless of success or failure
          if (res && res?.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            props.setOpen(false);
            // Call getUsers after updating specialization
            getUsers(1, 10, "ASC"); // Assuming these parameters are applicable
          }
        })
      );
    } else {
      const payload = {
        Id: 0,
        PlantId: data.PlantId.value,
        SocialInsCode: data.SocialInsCode,
        IsActive: true,
        IsDeleted: false,

      };
      dispatch(
        addNewSocMaster(payload, (res) => {
          reset();
          setLoading(false); // Set loading to false regardless of success or failure //loader
          if (res && res.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            props.setOpen(false);
            // window.location.reload()
            // Call getUsers after adding new specialization
            getUsers(1, 10, "ASC"); // Assuming these parameters are applicable
          }
        })
      );
    }

    // Add this line to check if data is received
    // alert("Submitted Updated request Data");

  };


  const renderListing = (label) => {

    if (label === "plantListData") {
      return plantList.map((plantList) => ({
        value: plantList.PlantCode,
        label: plantList.PlantWithCode,
      }));
    }
  };
  if (loading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  return (
    <>
      <div className="bg-white hl-common-page">
        <Drawer
          // anchor={props.anchor}
          open={props.open}
          // onClose={(e) => toggleDrawer(e)}
          anchor={"right"}
        >
          <Container>
            <div className={"drawer-wrapper"}>
              <Row className="drawer-heading">
                <Col>
                  <div className={"header-wrapper left"}>
                    <h3>{Id ? "Update SOC Master" : "Add SOC Master"}</h3>
                  </div>
                  <div onClick={closebtn} className={"close-button right"}></div>
                </Col>
              </Row>

              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <div>Loading...</div>
                </div>
              ) : (
                <div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="part-detail-wrapper pl-3 pr-3 mt-3 flex-column">
                      {/* {(Id && Id < 0) || Id === undefined && ( */}
                      <>
                        <Col md="12">
                          <SearchableSelectHookForm
                            {...register("PlantId")}
                            label={"Plant"}
                            name={"PlantId"}
                            placeholder={"Select"}
                            Controller={Controller}
                            control={control}
                            rules={{ required: true }}
                            // register={register}
                            options={renderListing("plantListData")}
                            mandatory={true}
                            handleChange={() => { }}
                            errors={errors.PlantId}
                            disabled={false}
                          />
                        </Col>
                        <Col md="12">
                          <TextFieldHookForm
                            {...register("SocialInsCode")}
                            label={`Social Industry Code`}
                            name={"SocialInsCode"}
                            onChange={(e) =>
                              setValue("SocialInsCode", e.target.value)
                            }
                            Controller={Controller}
                            rules={{
                              required: true,
                              validate: { checkWhiteSpaces },
                              maxLength: 20,
                            }}
                            control={control}
                            placeholder={"Enter"}
                            // register={register}
                            // className=""
                            customClassName={"withBorder mb-0"}
                            handleChange={() => { }}
                            errors={errors.SocialInsCode}
                            disabled={false}
                            mandatory={true}
                          />
                        </Col>
                      </>

                      <Col
                        md="12"
                        className="mt-3 justify-content-between d-flex"
                      >
                        <div className="col-sm-12 text-right">
                          <button
                            type={"button"}
                            className="reset mr15 cancel-btn"
                            onClick={cancel}
                          >
                            <div className={"cancel-icon"}></div> {"Cancel"}
                          </button>
                          <button
                            type="submit"
                            className="submit-button save-btn"
                          // onClick={() => setValue('ApproveAction', true)}
                          >
                            {/* <div className="save-icon"></div> {Id > 0 ? "Approve" : "Save"} */}
                            <div className="save-icon"></div> {Id ? "Update" : "Save"}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </div>
          </Container>
        </Drawer>
      </div>
    </>
  );
};

export default AddSocMaster;